import { render } from "./editInterventionModal.vue?vue&type=template&id=641f5922"
import script from "./editInterventionModal.vue?vue&type=script&lang=js"
export * from "./editInterventionModal.vue?vue&type=script&lang=js"

import "./editInterventionModal.vue?vue&type=style&index=0&id=641f5922&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__